<template>
    <b-container fluid>
        <b-row class="school-container-layout" id="results">
            <b-col cols="12" lg="3" class="results-content">
                <p class="results-text-title">Key de acceso</p>
            </b-col>
            <b-col cols="12" lg="9" class="results-title-line">
            </b-col>
        </b-row>
        <b-row>

            <b-col cols="12" class="results-content-search mt-3">
                <b-form-group id="form-search-simulacro">
                    <img src="@/assets/images/Search.svg">
                    <b-form-input
                            id="input-2"
                            v-model="search"
                            required
                            placeholder="Busca por código de key o grado y sección"
                            size="lg"
                    ></b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row class="mb-5">
            <b-col cols="12" class="results-content-simulacro-principal"
                   v-for="(items,key) in filteredData" :key="key"
            >
                <table-results
                        :item="items"
                        :id="key"
                        :filter-key="search"
                        :content="content">
                </table-results>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
    import TableResults from '@/components/Global/Results'
    import moment from 'moment'

    export default {
        name: 'ResultsSchool',
        components: {
            TableResults
        },
        data: () => ({
            search: '',
            data: [],
            content: {
                button1: {
                    name: 'POR GRUPO',
                    url: '/colegio/list-simulacros'
                },
                button2: {
                    name: 'POR ESTUDIANTE',
                    url: '/colegio/resultados-estudiantes'
                }
            }
        }),
        created() {
            let colegio = JSON.parse(localStorage.getItem('userdata'))
//            console.log('aqui colegio', localStorage.getItem('userdata'))
            let id_colegio = colegio.colegio.colegio_id
            this.$store.dispatch('setModulo', 'RESULTADOS')
            this.$store.dispatch('setNav', 'active')
            if(id_colegio) {
                this.$store.dispatch('getKeysColegio', id_colegio)
                    .then((response) => {
//                    console.log('resultadp de getKeysColegio response:', response)
                        this.data = response.data.map((obj) => {
                            return {
                                ...obj,
                                nombre: obj.nombre + ' - ' + moment(String(obj.desde)).format('YYYY') + ' ' + obj.grado + ' ' + obj.seccion,
                                desde: moment(String(obj.desde)).format('MM/DD/YYYY')
                            }
                        })
//                    console.log('resultadp de getKeysColegio:', this.data)
                    })
                    .catch((error) => {
                        console.log(error.message)
                    })
            }

        },
        methods: {
            goRouter(url) {
                console.log('aqui cambie setActiveRouteButton en result:', url)
                this.$store.dispatch('setActiveRouteButton', url)
                this.$router.push(url)
            }
        },
        computed: {
            filteredData: function () {
                var data = this.data
                var filterKey = this.search && this.search.toLowerCase()
                if (filterKey) {
                    data = data.filter(function (row) {
                        return Object.keys(row).some(function (key) {
                            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
                        })
                    })
                }
                return data
            }
        }
    }
</script>